import { mapWithIndex } from 'fp-ts/Record';
/**
 *  @since 0.0.1
 */
export const Predicates = (tag) => (keys) => ({
    is: mapWithIndex((key, _) => (rest) => rest[tag] === key)(keys),
    verified: (a) => a[tag] in keys,
    isAnyOf: (keys) => (rest) => keys.indexOf(rest[tag]) !== -1
});
